import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AuthPlugin from "./plugins/auth"
import RoutingPlugin from "./plugins/routePath"
import {initCommonInterceptors} from "./services/CommanServices"
import {initCmsInterceptors} from "./services/CmsServices"
import {initDealerInterceptors} from "./services/DealerService"
import {initReportInterceptors} from "./services/ReportsServices"
import {initEnrollmentInterceptors} from "./services/SetupEnrollmentServices"
import {initComplianceInterceptors} from "./services/ComplianceServices"
import VueCarousel from '@chenfengyuan/vue-carousel'
import FormField from "./components/FormField"
import i18n from './i18n'
import '@/gtm'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import { createGtag } from "vue-gtag";

const GA_MEASUREMENT_ID = 'G-71MYHWVKB5';

window.dataLayer = window.dataLayer || [];

export const eventBus = createApp(App);
const application = createApp(App);

application.config.productionTip = false;
application.component(FormField.name, FormField)
application.component(VueCarousel.name, VueCarousel);

const gtag = createGtag({
  tagId: "GA_MEASUREMENT_ID",
  params: {
    send_page_view: false
  }
})

application
.use(AuthPlugin)
.use(VueDOMPurifyHTML)
.use(RoutingPlugin)
.use(store)
.use(router)
.use(i18n)
.use(gtag)

application
.mixin({
  beforeCreate() {
      initCommonInterceptors();
      initCmsInterceptors();
      initDealerInterceptors();
      initReportInterceptors();
      initComplianceInterceptors();
      initEnrollmentInterceptors();
  }
})

application
.mount('#app')

